<template>
  <vacuum-valve :form="form" @goPageHome="goPageHome"></vacuum-valve>
</template>

<script>
import VacuumValve from "./VacuumValve";
import {getValveDetail} from "../api/api";
export default {
  name: "VacuumValve-8",
  components: {VacuumValve},
  data() {
    return {
      form: {
        pathName: this.$t('i18n.headerMain.vacuumValve'),
        lastPathName: this.$t('i18n.headerMainChildren.combinedValve'),
        name: "combinedValve",
        path: "VacuumValve8",
        isLast: false,
        pathImg: require('../assets/imgs/combinedValve.png'),
        img: require('../assets/imgs/combinedValveImg.png'),
        technicalImg: require('../assets/imgs/combinedValveTechnical.png'),
        downloadImg: require('../assets/imgs/combinedValveDownload.png'),
        propertiesName: "combinedValve",
        showFlg: true,
        type: "PDF",
        size: "4 MB"
      },
      list: [],
    }
  },

  created() {
    this.form.pathImg = this.isMobile() ? require('../assets/imgs/zuhefaPro.png') : require('../assets/imgs/zuhefaPro.png')
    this.search();
  },


  methods: {
    search() {
      getValveDetail({ id: "5" }).then(res => {
        if(res.data.code == 1){
          this.form.id = res.data.data.id;
          if (this.$store.state.language === '中文') {
            this.form.technicalImg = res.data.data.image;
          } else if (this.$store.state.language === 'English') {
            this.form.technicalImg = res.data.data.image2;
          }
        }
      });
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPageHome() {
      this.$router.push("VacuumValveMain");
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/VacuumValve-8.vue